import { BrandType } from 'utils/types';
import * as actionTypes from 'containers/Portfolio/PageHeader/action-types';

export type StateType = {
  readonly brands: Array<BrandType>;
  readonly selectedBrands: Array<string>;
  readonly showBrandFilter: boolean;
  readonly showBrandPicker: boolean;
  readonly transientSelectedBrands: Array<string>;
};

const initialState: StateType = {
  brands: [],
  selectedBrands: [],
  showBrandFilter: false,
  showBrandPicker: false,
  transientSelectedBrands: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGES_APPLY:
      return {
        ...state,
        selectedBrands: action.payload,
        showBrandFilter: false
      };
    case actionTypes.BRANDS_FILTER_MODAL_SHOW_SET:
      return {
        ...state,
        showBrandFilter: action.payload
      };
    case actionTypes.BRANDS_PICKER_MODAL_SHOW_SET:
      return {
        ...state,
        showBrandPicker: action.payload
      };
    case actionTypes.PORTFOLIO_BRANDS_INITIALIZE:
      return {
        ...state,
        brands: action.payload.brands,
        selectedBrands: action.payload.selectedBrands
      };
    case actionTypes.MODAL_OPEN:
      return {
        ...state,
        showBrandFilter: true,
        transientSelectedBrands: action.payload
      };
    case actionTypes.BRAND_PICKER_MODAL_OPEN:
      return {
        ...state,
        showBrandPicker: true,
        transientSelectedBrands: action.payload
      };
    case actionTypes.SELECTED_BRANDS_SET:
      return {
        ...state,
        selectedBrands: action.payload
      };
    case actionTypes.SELECTED_TRANSIENT_BRANDS_SET:
      return {
        ...state,
        transientSelectedBrands: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
